import AdminListView from '@/components/admin/AdminListView.vue';
import AdminAuctionEdit from '@/components/admin/AuctionEdit.vue';
import AdminContactView from '@/components/admin/ContactView.vue';
import AdminUserEdit from '@/components/admin/UserEdit.vue';
import AdminTermsView from '@/components/admin/TermsView.vue';
import { auctionModule, authModule, groupModule, routerModule } from '@/store';
import AccountNotices from '@/views/AccountNotices.vue';
import Admin from '@/views/Admin.vue';
import Auction from '@/views/Auction.vue';
import Auctions from '@/views/Auctions.vue';
import Bids from '@/views/Bids.vue';
import Contact from '@/views/Contact.vue';
import DynamicComponent from '@/views/DynamicComponent.vue';
import LandingPage from '@/views/LandingPage.vue';
import Login from '@/views/Login.vue';
import NotFound from '@/views/NotFound.vue';
import PasswordReset from '@/views/PasswordReset.vue';
import PermissionDenied from '@/views/PermissionDenied.vue';
import Profile from '@/views/Profile.vue';
import VerifyEmail from '@/views/VerifyEmail.vue';
import Wishlist from '@/views/Wishlist.vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: LandingPage,
    meta: {
      title: 'Home',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: PasswordReset,
    meta: {
      title: 'Forgotten your password',
    },
  },
  {
    path: '/set-password',
    name: 'set-password',
    component: PasswordReset,
    meta: {
      title: 'Set your password',
    },
  },
  {
    path: '/admin',
    name: 'admin',
    component: Admin,
    redirect: '/admin/auctions',
    meta: {
      roles: ['Administrators'],
      title: 'Admin',
    },
    children: [
      {
        path: 'users',
        name: 'admin-users',
        component: AdminListView,
        meta: { title: 'Users' },
      },
      {
        path: 'users/add',
        name: 'admin-users-add',
        component: AdminUserEdit,
        meta: { title: 'Add a User' },
      },
      {
        path: 'users/edit/:userId',
        name: 'admin-users-edit',
        component: AdminUserEdit,
        meta: { title: 'Edit a User' },
      },
      {
        path: 'auctions',
        name: 'admin-auctions',
        component: AdminListView,
        meta: { title: 'Auctions' },
      },
      {
        path: 'auctions/add',
        name: 'admin-auctions-add',
        component: AdminAuctionEdit,
        meta: { title: 'Add an Auction' },
      },
      {
        path: 'auctions/edit/:auctionId',
        name: 'admin-auctions-edit',
        component: AdminAuctionEdit,
        meta: { title: 'Edit an Auction' },
      },
      {
        path: 'media',
        name: 'admin-media',
        component: AdminListView,
        meta: { title: 'Media Upload' },
      },
      {
        path: 'contact',
        name: 'admin-contact',
        component: AdminListView,
        meta: { title: 'Contact Form' },
      },
      {
        path: 'contact/view/:messageId',
        name: 'admin-contact-view',
        component: AdminContactView,
        meta: { title: 'View Message' },
      },
      {
        path: 'terms',
        name: 'admin-terms',
        component: AdminTermsView,
        meta: { title: 'Terms and Conditions' },
      },
    ],
  },
  {
    path: '/auctions',
    name: 'auctions',
    component: Auctions,
    meta: {
      title: 'Auctions',
    },
  },
  {
    path: '/auction/:auctionId',
    name: 'auction',
    component: Auction,
    meta: {
      title: 'Auction',
    },
  },
  {
    path: '/bids',
    name: 'bids',
    component: Bids,
    meta: {
      title: 'My Bids',
    },
  },
  {
    path: '/wishlist',
    name: 'wishlist',
    component: Wishlist,
    meta: {
      title: 'My Wishlist',
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      title: 'Profile',
    },
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: {
      title: 'Contact Us',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login',
    },
  },
  {
    // What a user with an outstanding obligation is linked to, and redirected
    // to on a credential login. Above the `/:test*` catch-all, like the route
    // below, which would otherwise swallow it.
    path: '/account/notices',
    name: 'account-notices',
    component: AccountNotices,
    meta: {
      title: 'Notices',
    },
  },
  {
    // Landing page for the link in a verification email. Must sit above the
    // `/:test*` catch-all, which would otherwise swallow it.
    path: '/verify-email',
    name: 'verify-email',
    component: VerifyEmail,
    meta: {
      title: 'Confirm your email address',
    },
  },
  {
    path: '/permission-denied',
    name: 'denied',
    component: PermissionDenied,
    meta: {
      title: 'Permission denied',
    },
  },
  {
    path: '/:test*',
    name: 'dynamic-component',
    component: DynamicComponent,
  },
  {
    path: '/*',
    name: 'not-found',
    component: NotFound,
    meta: {
      title: 'Page not Found',
    },
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log(to);
    // console.log(from);
    if (
      to.name === 'auction' &&
      from.name === 'auction' &&
      to.query.lot !== from.query.lot
    ) {
      return;
    }

    return { x: 0, y: 0 };
  },
});

// could potentially move this to App.vue

router.beforeEach(async (to, from, next) => {
  // get the SPA ready by checking if logged in etc
  if (!authModule.ready) {
    await authModule.init();
    await routerModule.init();
  }

  // check permissions on route
  const roles = to.matched.reduce(
    (combined, route) => [...combined, ...((route.meta.roles as []) || [])],
    [],
  );
  if (!authModule.canAccess(roles)) {
    next({ name: 'denied' });
  } else {
    next();
  }
});

export default router;
